import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, inject } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { IGuestCart } from '../../../models/guest.models';
import { ImageUtils } from '../../../utils/image.utils';
import { MarketingFacade } from '../../../facades/marketing.facade';

@Component({
  selector: 'app-guest-cart',
  templateUrl: './guest-cart.component.html',
  styleUrl: './guest-cart.component.scss',
  standalone: false,
})
export class GuestCartComponent implements OnInit {
  private marketingFacade: MarketingFacade = inject(MarketingFacade);
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);


  protected readonly ImageUtils: typeof ImageUtils = ImageUtils;

  guestCart!: IGuestCart;
  guestCartLoading: boolean = true;

  /**
   * Initializes the guest cart data.
   */
  ngOnInit(): void {
    this.marketingFacade.selectGuestCart().pipe(
      filter((guestCart): guestCart is IGuestCart => guestCart !== null),
      take(1),
    ).subscribe(guestCart => {
      this.guestCart = guestCart;
      this.guestCartLoading = false;
    });
  }

  /**
   * Navigates to the guest delivery details page.
   */
  proceedToNextStep(): void {
    this.router.navigate(
      [`checkout/delivery-details/${this.route.snapshot.paramMap.get('guestUserId')}/${this.route.snapshot.paramMap.get('guestCartId')}`],
    );
  }
}
